module.exports = __webpack_public_path__ + "assets/img/2b4d34e9b8bac1c7c16f8440c2f6e6a6.svg";